import { ExtendedCardWrapperProps } from './ExtendedCardWrapper';
import getActionBarText from '../utils/getActionBarText';
import { observer } from 'mobx-react-lite';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { logUsage } from 'owa-analytics';
import { ControlIcons } from 'owa-control-icons';
import { getIsDarkTheme } from 'owa-fabric-theme';
import setCoverOriginalContent from 'owa-mail-reading-pane-store/lib/actions/setCoverOriginalContent';
import * as React from 'react';

const styles = require('./ExtendedCardFullViewCollapsableWrapper.scss');
const classNames = require('classnames/bind').bind(styles);

interface ExtendedCardFullViewCollapsableWrapperProps extends ExtendedCardWrapperProps {
    children?: JSX.Element | JSX.Element[];
}

export const ExtendedCardFullViewCollapsableWrapper = observer(
    function ExtendedCardFullViewCollapsableWrapper(
        props: ExtendedCardFullViewCollapsableWrapperProps
    ) {
        const expandedByDefault = !!props.extendedCardViewState.coverOriginalContent;

        const expandOrCollapse = React.useCallback(
            (shouldExpand: boolean) => {
                setCoverOriginalContent(props.extendedCardViewState, shouldExpand);
                logUsage(
                    'ExtendedCard_ExpandCollapse',
                    {
                        cardType: props.extendedCardViewState.cardType.toString(),
                        didExpand: shouldExpand /*didExpand*/,
                        expandedByDefault: expandedByDefault,
                    },
                    { logEvery: 1 }
                );
            },
            [props.extendedCardViewState]
        );

        const collapse = React.useCallback(() => {
            expandOrCollapse(false /*shouldExpand*/);
        }, []);

        const expand = React.useCallback(() => {
            expandOrCollapse(true /*shouldExpand*/);
        }, []);

        const isCollapsed = !props.extendedCardViewState.coverOriginalContent;
        const expandCollapseText = getActionBarText(
            props.extendedCardViewState.cardType,
            isCollapsed
        );

        return (
            <div
                className={classNames(styles.container, {
                    isCollapsed: isCollapsed,
                })}>
                <div
                    className={classNames(styles.body, 'customScrollBar', {
                        isCollapsed: isCollapsed,
                    })}>
                    {props.children}
                </div>

                <div
                    className={classNames(styles.actionBar, {
                        isCollapsed: isCollapsed,
                        isDarkTheme: getIsDarkTheme(),
                    })}
                    onClick={isCollapsed ? expand : collapse}>
                    <span className={styles.actionBarText}>{expandCollapseText}</span>
                    <Icon
                        className={styles.expandCollapseButton}
                        iconName={isCollapsed ? ControlIcons.ChevronDown : ControlIcons.ChevronUp}
                        ariaLabel={expandCollapseText}
                        aria-expanded={!isCollapsed}
                        title={expandCollapseText}
                    />
                </div>
            </div>
        );
    }
);

export default ExtendedCardFullViewCollapsableWrapper;
